import * as yup from 'yup';
import {
    alphabetRegix,
    alphaNumericRegix,
    numericRegix,
    phoneRegex,
} from '../utils/functions';
import { isValidPhoneNumber } from 'libphonenumber-js';

const nonRequiredIds = ['39', '37', '41', '1480'];

export const individual_employer_info_validation_schema = yup.object().shape({

    employmentStatusId: yup
        .string()
        .required('please_select_employee_status'),

    nameOfEmployee: yup
        .string()
        .max(100, 'employer_name_must_not_exceed')
        .when('employmentStatusId', {
            is: val => !nonRequiredIds.includes(String(val)),
            then: schema =>
                schema
                    .required('employer_name_is_required')
                    .matches(alphaNumericRegix, 'must_be_alphanumeric'),
            otherwise: schema => schema.notRequired(),
        }),

    employersAddress: yup
        .string()
        .max(100, 'employer_address_must_not_exceed_arabic')
        .when('employmentStatusId', {
            is: val => !nonRequiredIds.includes(String(val)),
            then: schema =>
                schema
                    .required('employer_address_is_required')
                    .matches(alphaNumericRegix, 'must_be_alphanumeric'),
            otherwise: schema => schema.notRequired(),
        }),

    employersPhoneNumber: yup
        .string()
        .nullable()
        .notRequired()
        .test(
            'valid-phone',
            'invalid_phone_no',
            function (value) {
                if (!value || value.trim() === '') {
                    return true; // ✅ Empty allowed
                }
                return isValidPhoneNumber(value);
            }
        ),

    position: yup
        .string()
        .max(100, 'position_must_not_exceed')
        .when('employmentStatusId', {
            is: val => !nonRequiredIds.includes(String(val)),
            then: schema =>
                schema
                    .required('position_is_required')
                    .min(4, 'min_4_characters'),
            otherwise: schema => schema.notRequired(),
        }),

    durationOfEmploymentId: yup
        .object()
        .when('employmentStatusId', {
            is: val => !nonRequiredIds.includes(String(val)),
            then: schema =>
                schema.required('employement_duration__is_required'),
            otherwise: schema => schema.notRequired(),
        }),

});
